import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { ApiSmsHelperService } from './sms-helper.service';

@Injectable({ providedIn: 'root' })
export class ApiSmsService {
  constructor(public hpr: ApiSmsHelperService, private _api: ApiService) {}

  get(id: number | string) {
    return this._api.get('sms/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('sms/list', data);
  }

  create(data: any) {
    return this._api.post('sms/create', data);
  }

  update(data: any) {
    return this._api.post('sms/update', data);
  }

  remove(id: number) {
    return this._api.post('sms/remove/id/' + id);
  }
}
